module.exports = __webpack_public_path__ + "static/portfolio-1074a13a184577e74f8bb9f9a74c85ae.png";